export const FINISH_INITIAL_LOADING = 'FINISH_INITIAL_LOADING';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const SHOW_FOOTER = 'SHOW_FOOTER';
export const SHOW_MENU_BUTTON = 'SHOW_MENU_BUTTON';

